// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

// Afidium
import { TravelDateComponent } from './travel-date.component';
import { DatesModule } from 'app_sasha/shared/services/dates/dates.module';
import { DatePipeModule } from 'libraries/date/date.module';

@NgModule({
    imports: [
        CommonModule,
        DatesModule,
        DatePipeModule,
    ],
    exports: [TravelDateComponent],
    declarations: [TravelDateComponent],
})
export class TravelDateModule {}

